const getNights = nights => {
  if (nights.min === nights.max) {
    return `${nights.min} Nächte`
  } else {
    return `${nights.min}-${nights.max} Nächte`
  }
}

const getPersons = persons => {
  if (persons.min === persons.max) {
    return `${persons.min} Personen`
  } else {
    return `${persons.min} - ${persons.max} Personen`
  }
}

// const getThemes = item => {
//   if (item.themes != undefined) {
//     return item.themes.map(f => f.name).join(',')
//   }

//   return ''
// }

// const loadMetaDataForOrder = async (id, token) => {
//   return await checkoutApi.metaData(id, token)
// }

// const getThemesString = (id, data) => {
//   let item = data.items.find(f => f.id == id)
//   if (item) {
//     return item.themes.map(f => f.name).join(',')
//   }
//   return ''
// }

const getProductList = (mode, brand, productList) => {
  let gtmItems = []

  for (let i = 0; i < productList.length; i++) {
    let item = productList[i]
    let obj = {}

    if (mode === 'ua') {
      obj = {
        name: item.display,
        id: `wearetravel_${item.id}`,
        price: item.price.display,
        brand: brand,
        category: 'Urlaubsgutscheine',
        //category: getThemes(item),
        variant: `${getNights(item.nights)}, ${getPersons(item.persons)}`,
        list: 'Search Results',
        position: i,
      }
    } else {
      obj = {
        item_name: item.display,
        item_id: `wearetravel_${item.id}`,
        item_list_name: 'Search Results',
        item_brand: brand,
        item_variant: `${getNights(item.nights)}, ${getPersons(item.persons)}`,
        //item_category: getThemes(item),
        item_category: 'Urlaubsgutscheine',
        price: item.price.display,
        index: i,
      }
    }

    gtmItems.push(obj)
  }

  return gtmItems
}

const getProduct = (mode, brand, product) => {
  let item = {}

  if (mode === 'ua') {
    item = {
      name: product.display,
      id: `wearetravel_${product.id}`,
      price: product.price.display,
      brand: brand,
      item_list_name: 'Search Results',
      //category: getThemes(product),
      category: 'Urlaubsgutscheine',
      variant: `${getNights(product.nights)}, ${getPersons(product.persons)}`,
      // position: 'Position',
    }
  } else {
    item = {
      item_name: product.display,
      item_id: `wearetravel_${product.id}`,
      item_brand: brand,
      item_list_name: 'Search Results',
      //item_category: getThemes(item),
      item_category: 'Urlaubsgutscheine',
      item_variant: `${getNights(product.nights)}, ${getPersons(
        product.persons,
      )}`,
      price: product.price.display,
    }
  }

  return item
}

//returns object for hoteldisplay
const getProductView = (mode, brand, product) => {
  let item = {}

  let nights = {
    min: product.variants.reduce(
      (min, p) => (p.nights < min ? p.nights : min),
      product.variants[0].nights,
    ),
    max: product.variants.reduce(
      (max, p) => (p.nights > max ? p.nights : max),
      product.variants[0].nights,
    ),
  }

  let persons = {
    min: product.variants.reduce(
      (min, p) => (p.persons < min ? p.persons : min),
      product.variants[0].persons,
    ),
    max: product.variants.reduce(
      (max, p) => (p.persons > max ? p.persons : max),
      product.variants[0].persons,
    ),
  }

  if (mode === 'ua') {
    item = {
      name: product.title,
      id: `wearetravel_${product.id}`,
      brand: brand,
      //price: '15.25',
      //category: getThemes(product),
      category: 'Urlaubsgutscheine',
      variant: `${getNights(nights)}, ${getPersons(persons)}`,
    }
  } else {
    item = {
      item_name: product.title,
      item_brand: brand,
      item_id: `wearetravel_${product.id}`,
      //item_category: getThemes(product),
      item_category: 'Urlaubsgutscheine',
      item_variant: `${getNights(nights)}, ${getPersons(persons)}`,
      item_list_name: 'Search Results',
    }
  }

  return item
}

const getCartList = (mode, brand, cartList) => {
  let gtmItems = []
  let productList = [...cartList]

  if (mode === 'ua') {
    for (let i = 0; i < productList.length; i++) {
      let item = productList[i]
      let obj = {
        name: item.title,
        id: `wearetravel_${item.id}`,
        price: item.unitPrice,
        brand: brand,
        //category: getThemes(item),
        category: 'Urlaubsgutscheine',
        variant: `${item.parameter.nights} Nächte, ${item.parameter.persons} Personen`,
        quantity: item.quantity,
      }
      gtmItems.push(obj)
    }
  } else {
    for (let i = 0; i < productList.length; i++) {
      let item = productList[i]
      let obj = {
        item_description: item.title,
        item_id: `wearetravel_${item.id}`,
        item_variant: `${item.parameter.nights} Nächte, ${item.parameter.persons} Personen`,
        item_brand: brand,
        //item_category: getThemes(item),
        item_category: 'Urlaubsgutscheine',
        price: item.unitPrice,
        index: i,
        quantity: item.quantity,
      }
      gtmItems.push(obj)
    }
  }

  return gtmItems
}

export const getPurchasedList = (mode, brand, purchasedList) => {
  let gtmItems = []
  //let metaData = await loadMetaDataForOrder(id, token)
  if (mode === 'ua') {
    for (let i = 0; i < purchasedList.length; i++) {
      let item = purchasedList[i]
      //let themes = getThemesString(item.variantId, metaData)
      let obj = {
        name: item.title,
        id: `wearetravel_${item.id}`,
        brand: brand,
        price: item.unitPrice,
        //category: themes,
        category: 'Urlaubsgutscheine',
        variant: `${item.parameter.nights} Nächte, ${item.parameter.persons} Personen`,
        quantity: item.quantity,
        //coupon: '',
      }
      gtmItems.push(obj)
    }
  } else {
    for (let i = 0; i < purchasedList.length; i++) {
      let item = purchasedList[i]
      let obj = {
        item_name: item.title,
        item_id: `wearetravel_${item.id}`,
        item_brand: brand,
        item_price: item.unitPrice,
        item_quantity: item.quantity,
        item_variant: `${item.parameter.nights} Nächte, ${item.parameter.persons} Personen`,
      }
      gtmItems.push(obj)
    }
  }

  return gtmItems
}

export default {
  getProductList,
  getProduct,
  getProductView,
  getCartList,
  getPurchasedList,
}
